export default "__VITE_ASSET__ODduCXuM__"